import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_2 = { class: "col-1 mt-3 mb-3" }
const _hoisted_3 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_6 = { class: "visually-hidden" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "row justify-content-center" }
const _hoisted_9 = {
  key: 0,
  class: "col-12"
}
const _hoisted_10 = {
  key: 1,
  class: "col-12"
}
const _hoisted_11 = { class: "row justify-content-center" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "row text-sm-left" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "col-12 mt-3" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "col-12 mt-3" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "col-12 mt-3" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "row mt-4" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "row justify-content-center mt-2" }
const _hoisted_27 = { class: "col-12 d-grid gap-2" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_30 = {
  class: "alert alert-success col-12",
  role: "alert"
}
const _hoisted_31 = {
  key: 2,
  class: "row"
}
const _hoisted_32 = {
  class: "alert alert-danger col-12",
  role: "alert"
}
const _hoisted_33 = {
  key: 0,
  class: "text-xs-center mt-2"
}
const _hoisted_34 = {
  key: 1,
  class: "row mt-4"
}
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = { class: "col-12" }
const _hoisted_37 = { class: "it-list-wrapper" }
const _hoisted_38 = { class: "it-list" }
const _hoisted_39 = { class: "list-item" }
const _hoisted_40 = { class: "it-right-zone" }
const _hoisted_41 = { class: "text" }
const _hoisted_42 = {
  key: 2,
  class: "row mt-4"
}
const _hoisted_43 = { class: "col col-md-6 col-xs-12" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "col col-md-6 col-xs-12" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = { class: "modal-header" }
const _hoisted_50 = {
  class: "modal-title h5 no_toc",
  id: "confirmDeleteModalLabel"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, null, -1)
const _hoisted_52 = { class: "modal-body" }
const _hoisted_53 = { class: "modal-footer" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 1,
  class: "text-center"
}
const _hoisted_58 = { class: "progress-spinner progress-spinner-active size-sm" }
const _hoisted_59 = { class: "visually-hidden" }

import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import api from "@/services/BookingService";
import tenantApi from "@/services/TenantService";
import _ from "lodash";
import { Modal } from "bootstrap-italia";

import moment from "moment";
import { useI18n } from "vue-i18n";
import { useToolbar } from "@/composables/useToolbar";
import { CheckinRequestItem } from "@/models/Appointment/CheckinRequestItem";
import { useWidget } from "@/composables/useWidget";
import { useTenantConfig } from "@/composables/useTenantConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkin',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const { t } = useI18n();
const toolbar = useToolbar();
const { rootElement } = useWidget();
const tenantConfig = useTenantConfig();

const loading = ref(true);
const checkInErrorMessage = ref("");
const checkInSuccess = ref("");
const checkInError = ref(false);
const checkInTooLate = ref(false);
const isLoadingCheckin = ref(false);
const isLoadingEdit = ref(false);
const confirmDeleteDialog = ref(false);
const isDeletingBooking = ref(false);
const errorMessage = ref(t("messages.errorBookingDelete"));

const confirmDeleteRef = ref();
var confirmDeleteModal: any;

const attentionTitle = computed(() => {
    return t("common.attention");
});

const bookToEdit = computed(() => {
    return store.bookedit;
});

const welcomeText = computed(() => {
    return t("messages.checkInWelcome").replace("##FirstName##", bookToEdit.value.lastName).replace("##LastName##", bookToEdit.value.firstName).replace("##TenantName##", bookToEdit.value.tenant.name);
});

const bookingDateTime = computed(() => {
    return moment(bookToEdit.value.fromDate).format(t("settings.dateTimeUIFormat"));
});

const confirmDeleteMessage = computed(() => {
    return t("messages.confirmCancelBooking").replace("##bookingCode##", bookToEdit.value.friendlyCode);
});

const categoriesFromBooking = computed(() => {
    if (bookToEdit.value.slots.length == 1) return null;
    const categoriesArray = bookToEdit.value.slots.map((item) => {
        return item.service.categoryName;
    });

    const categories = _.uniq(categoriesArray);
    return categories.join(", ");
});

const serviceFromBooking = computed(() => {
    const servicesArray = bookToEdit.value.slots.map((item) => {
        return item.service.name;
    });

    const services = _.uniq(servicesArray);
    return services.join(", ");
});

const documentsFromBooking = computed(() => {
    const documents: string[] = [];
    for (let index = 0; index < bookToEdit.value.slots.length; index++) {
        const item = bookToEdit.value.slots[index];
        if (item.service.serviceInfo) {
            var docs = item.service.serviceInfo.split("|");
            for (var j = 0; j < docs.length; j++) {
                if (
                    documents.some(function (item) {
                        return item == docs[j];
                    }) == false
                ) {
                    documents.push(docs[j]);
                }
            }
        }
    }
    return documents;
});

const checkInDescription = computed(() => {
    if (checkInSuccess.value) {
        return checkInSuccess.value;
    } else {
        const checkin = _.find(bookToEdit.value.trackings, function (o) {
            return o.eventType === "checkin";
        });

        if (checkin) {
            return `Check-in effettuato ${moment(checkin.createDate).format(t("settings.dateTimeUIFormat"))}`;
        } else {
            return null;
        }
    }
});

const canManageBooking = computed(() => {
    const isPast = moment(bookToEdit.value.fromDate).isBefore(moment());
    return !isPast && !checkInDescription.value && !checkInTooLate.value && !isLoadingCheckin.value;
});

const canDoCheckin = computed(() => {
    return bookToEdit.value.room.location.roomType !== 2;
});

const findBooking = (keycode: string, hashCode: string) => {
    loading.value = true;
    api.getBookingInfo(keycode, hashCode)
        .then((res) => {
            if (res && res.data && res.data.booking) {
                store.bookedit = res.data.booking;
                loading.value = false;
            }
        })
        .catch((err) => {
            if (err && err.response) {
                if (err.response.status === 500) {
                    if (err.response.data && err.response.data.errorMessage) {
                        errorMessage.value = err.response.data.errorMessage;
                    }
                }
            }
            loading.value = false;
        });
};

onMounted(() => {
    const localeCode = t("settings.localeCode");
    moment.locale(localeCode);

    if (confirmDeleteRef.value) {
        confirmDeleteModal = new Modal(confirmDeleteRef.value, {
            backdrop: "static"
        });
    }
    var bookingHashCode = "";
    if (route.params.keycode) {
        const bookingKeyCode = route.params.keycode.toString();
        if (route.query.c) {
            bookingHashCode = route.query.c.toString();
        }
        findBooking(bookingKeyCode, bookingHashCode);
    }
});

const openConfirmDeleteDialog = () => {
    if (confirmDeleteRef.value) {
        confirmDeleteModal = new Modal(confirmDeleteRef.value, {
            backdrop: "static"
        });
    }

    confirmDeleteModal.show();
};

const closeConfirmDeleteDialog = () => {
    confirmDeleteModal.hide();
};

const deleteBooking = (source: string) => {
    api.deleteBooking(bookToEdit.value.code, bookToEdit.value.keyCode, source)
        .then((res) => {
            if (res) {
                router.push({ name: "deleted" });
            }
        })
        .catch((err) => {
            if (err && err.response) {
                if (err.response.status === 500) {
                    if (err.response.data && err.response.data.errorMessage) {
                        errorMessage.value = err.response.data.errorMessage;
                    }
                }
            }
            console.log(err);
        })
        .finally(() => {
            isDeletingBooking.value = false;
            closeConfirmDeleteDialog();
        });
};

const doCheckin = () => {
    isLoadingCheckin.value = true;
    checkInError.value = false;
    checkInTooLate.value = false;
    checkInErrorMessage.value = "";
    const data: CheckinRequestItem = {
        bookingId: bookToEdit.value.id,
        deviceId: "utente-web"
    };
    api.doCheckin(data)
        .then((res) => {
            if (res) {
                checkInSuccess.value = "Check-in effettuato con successo";
            }
        })
        .catch((err) => {
            if (err && err.response) {
                checkInError.value = true;
                if (err.response.status === 400) {
                    if (err.response.data && err.response.data.details) {
                        checkInErrorMessage.value = err.response.data.details[0].value;
                        if (err.response.data.description === "BOOKING_CHECKIN_LATE") {
                            checkInTooLate.value = true;
                        }
                    }
                }
                if (err.response.status === 500) {
                    if (err.response.data && err.response.data.errorMessage) {
                        checkInErrorMessage.value = err.response.data.errorMessage;
                    }
                }
            }
        })
        .finally(() => {
            isLoadingCheckin.value = false;
        });
};

const editBooking = () => {
    const comuniQuery: string[] = [];
    isLoadingEdit.value = true;
    const newUrlToHome: any = {
        name: "checkin",
        params: { keycode: bookToEdit.value.keyCode }
    };
    toolbar.updateHomeRoute(newUrlToHome);
    store.tenantSelected = bookToEdit.value.tenant;

    tenantApi
        .getConfigurations(bookToEdit.value.tenant.id, comuniQuery, [])
        .then(() => {
            if (bookToEdit.value.slots.length > 1) {
                router.push({ name: "probook" });
            } else {
                const serviceRouteSelection = tenantConfig.getRouteNameServiceSelection();
                router.push({ name: serviceRouteSelection });
            }
        })
        .catch((err) => {
            if (err && err.response) {
                console.log(err);
            }
        })
        .finally(() => {
            isLoadingEdit.value = false;
        });
};

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("common.loadingText")), 1)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (bookToEdit.value === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("h2", null, _toDisplayString(_unref(t)("messages.bookingNotFound")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("h2", null, _toDisplayString(welcomeText.value), 1)
              ]))
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h5", null, [
                _createElementVNode("b", null, _toDisplayString(_unref(t)("titles.yourBooking")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", null, [
                _createElementVNode("b", null, _toDisplayString(_unref(t)("common.bookingCode")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", null, _toDisplayString(bookToEdit.value.friendlyCode), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", null, [
                _createElementVNode("b", null, _toDisplayString(_unref(t)("common.services")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", null, _toDisplayString(serviceFromBooking.value), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", null, [
                _createElementVNode("b", null, _toDisplayString(_unref(t)("common.location")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", null, _toDisplayString(bookToEdit.value.room.location.city) + " " + _toDisplayString(bookToEdit.value.room.location.address), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", null, [
                _createElementVNode("b", null, _toDisplayString(_unref(t)("common.date")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", null, _toDisplayString(bookingDateTime.value), 1)
            ])
          ])
        ]),
        (canDoCheckin.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
              (!checkInDescription.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", null, [
                          _createElementVNode("b", null, _toDisplayString(_unref(t)("messages.checkInNotification")), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary btn-block",
                          onClick: doCheckin,
                          disabled: isLoadingCheckin.value || isLoadingEdit.value
                        }, _toDisplayString(_unref(t)("common.doCheckIn")), 9, _hoisted_28)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(checkInDescription.value), 1)
                  ])),
              (checkInError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createTextVNode(_toDisplayString(checkInErrorMessage.value) + " ", 1),
                      (checkInTooLate.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-block",
                              onClick: editBooking
                            }, [
                              _createElementVNode("label", null, _toDisplayString(_unref(t)("messages.clickHereNewBooking")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (documentsFromBooking.value && documentsFromBooking.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", null, [
                  _createElementVNode("b", null, _toDisplayString(_unref(t)("common.requestedDocuments")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("ul", _hoisted_38, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentsFromBooking.value, (item) => {
                      return (_openBlock(), _createElementBlock("li", { key: item }, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("span", _hoisted_41, _toDisplayString(item), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (canManageBooking.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-block",
                  onClick: editBooking,
                  disabled: isLoadingCheckin.value || isLoadingEdit.value
                }, _toDisplayString(_unref(t)("common.editBooking")), 9, _hoisted_44)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger btn-block",
                  onClick: openConfirmDeleteDialog,
                  disabled: isLoadingCheckin.value || isLoadingEdit.value
                }, _toDisplayString(_unref(t)("common.deleteBooking")), 9, _hoisted_46)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          ref_key: "confirmDeleteRef",
          ref: confirmDeleteRef,
          class: "modal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "confirmDeleteModalLabel",
          "aria-hidden": "true",
          "data-bs-backdrop": "static",
          "data-bs-keyboard": "false"
        }, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("h2", _hoisted_50, _toDisplayString(attentionTitle.value), 1),
                _hoisted_51
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("p", null, _toDisplayString(confirmDeleteMessage.value), 1)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-primary btn-sm",
                  onClick: closeConfirmDeleteDialog,
                  disabled: isDeletingBooking.value
                }, _toDisplayString(_unref(t)("common.cancel")), 9, _hoisted_54),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteBooking('web'))),
                  disabled: isDeletingBooking.value
                }, [
                  (!isDeletingBooking.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_unref(t)("common.confirm")), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(t)("common.loadingText")), 1)
                        ])
                      ]))
                ], 8, _hoisted_55)
              ])
            ])
          ])
        ], 512)
      ]))
}
}

})